export const API_URL = "https://agentapi.phoenixcfportal.co.uk/";
export const EXPORT_API_URL =
  "https://agentapi.phoenixcfportal.co.uk/ExcelExport/";

// Local development config (uncomment when working on MAMP)
// export const API_URL = "http://localhost:8888/Phoenix/Phoenix-React-API/";
// export const EXPORT_API_URL =
//   "http://localhost:8888/Phoenix/Phoenix-React-API/ExcelExport/";
export const s3BaseUrl =
  "https://pheonix-upload-data.s3.eu-west-2.amazonaws.com/";

// export const API_URL = 'https://qa.apithala.getitnow.digital/';
// export const API_URL = 'https://api.getitnow.digital/getitnow-react-api/';
